exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget--border-box.social-grid .media-lists li[data-v-1dc822c6]{flex:0 0 25.000%;-webkit-flex:0 0 25.000%;-ms-flex:0 0 25.000%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1dc822c6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Impressum.vue
// module id = 188
// module chunks = 0